import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";

import { useCart } from "../../components/CartContext/CartContext";

import ExchangeOptions from "../../components/ExchangeOptions/ExchangeOptions";

import RefillModalSelection from "../../components/RefillModalSelection/RefillModalSelection";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import CartSubscribeSection from "../../components/CartSubscribeSection/CartSubscribeSection";
import { ProductService } from "../../APIs";

import Header from "../../components/Header/Header";

import { useNotification } from "../../components/Toast/Notification";
import { Puff } from "react-loader-spinner";
import {  Images } from "../../assets/assets";
import RefillFAQ from "../../components/RefillFAQ/RefillFAQ";
import { Faq } from "../../@types/faq";

const Loader: React.FC = () => {
  return (
    <div className="flex items-center justify-center">
      <Puff
        visible={true}
        height="60"
        width="60"
        color="#75A7AD"
        ariaLabel="puff-loading"
      />
    </div>
  );
};

const cardData = [
  {
    id: 1,
    image:
      "https://sodastream.co.uk/cdn/shop/files/Online-1.jpg?v=1662896579&width=800",
    title: "Place Order",
    content:
      "Running low on gas? Order a refill and send back your empty cylinders",
  },
  {
    id: 2,
    image:
      "https://sodastream.com/cdn/shop/files/exchange_online_672X460_deliver.jpg?v=1708590968&width=800",
    title: "We deliver",
    content:
      "We'll deliver you full cylinders with a return box and free mail return label. The return shipment is on us!",
  },
  {
    id: 3,
    image:
      "https://sodastream.co.uk/cdn/shop/files/InStore-3.jpg?v=1662896532&width=800",
    title: "You return",
    content:
      "Box up your empty capped cylinders, stick on the free return label, and either send the box back via USPS or leave it in your mailbox to be picked up. You have up to 60 days to return your empties! It's that easy!",
  },
];

const cardData2 = [
  {
    id: 1,
    image:
      "https://sodastream.co.uk/cdn/shop/files/InStore-1.jpg?v=1662896403&width=800",
    title: "Search for a store",
    content: (
      <>
        Visit our store locator, for retailers near you.{" "}
        <a
          href="/store-locator"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 underline">
          Click here
        </a>
        .
      </>
    ),
  },
  {
    id: 2,
    image:
      "https://sodastream.co.uk/cdn/shop/files/InStore-2.jpg?v=1662896466&width=800",
    title: "Visit the retailer",
    content: "Take your empty SodaStream CO2 cylinders to the retailer.",
  },
  {
    id: 3,
    image:
      "https://sodastream.co.uk/cdn/shop/files/InStore-3.jpg?v=1662896532&width=800",
    title: "Switch the cylinder",
    content: "Hand in your empty cylinders and only pay for a refill",
  },
];

export interface Product {
  id: number;
  title: string;
  price: number;
  image: string;
  banner: string;
  order_type?: string;
  quantity?: string;
}

const Refill = () => {
  const [openSections, setOpenSections] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const toggleSection = (index: number) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [index]: !Boolean(prevState[index]),
    }));
  };
  const { notify } = useNotification();

  // const faqs = [
  //   {
  //     title: "What is the difference between the SodaStream CO2 Cylinders?",
  //     content: `
  //       <p><strong>SodaStream offers 2 types of CO2 cylinders: the Quick Connect and Screw-in system.</strong></p>
  //       <img src="https://sodastream.co.uk/cdn/shop/files/Cylinder-US_91c78c62-3d3d-450b-a19b-327a17ac1e7b.png?v=1711025553" alt="CO2 Cylinders representation" style="width: 150px; height: 150px; padding:15px;" />
        
  //       <h4>Quick Connect system</h4>
  //       <p>The Original SodaStream Quick Connect CO2 Cylinder was designed with the following advantages:</p>
  //       <ul>
  //         <li><strong>Quick Connect technology:</strong> Designed to match our sparkling water makers with its quick-connect solution (insertion in one 'click', thus making the cylinder inserting process faster and more user-friendly), so the two work together seamlessly.</li>
  //         <li><strong>Circular forever:</strong> They are reusable, refillable, and recyclable, making them a sustainable choice for you and for the planet.</li>
  //         <li><strong>Triple-quality controlled:</strong> Each cylinder is cleaned, filled, and sealed with care to ensure maximum freshness and carbonation.</li>
  //       </ul>
  //       <p><strong>Sparkle Tip:</strong> Not sure if it is a cylinder for the SodaStream Quick Connect system? If it has a pink valve seal on top, it is for the SodaStream Quick Connect system!</p>
        
  //       <h4>Screw-in system</h4>
  //       <p>Same iconic sky-blue SodaStream design. The SodaStream Screw-in CO2 Cylinder remains with the same iconic design and compatible with these Sparkling Water Makers.</p>
  //     `,
  //     image: "",
  //   },
  //   {
  //     title: "How do I know if my SodaStream CO2 Cylinder is empty?",
  //     content: `
  //       <p>Not getting enough bubbles with your Sparkling Water Maker? We can help.</p>
        
  //       <h4>Quick Connect System</h4>
  //       <ul>
  //         <li>Make sure the cylinder is properly inserted in the cylinder holder, with the cylinder handle lowered.</li>
  //         <li>Push the carbonating lever down and check if you see CO2 entering the bottle.</li>
  //         <li>Push the carbonating lever down a few times and check for bubbles.</li>
  //         <li>Listen for a sputtering sound when you press the button.</li>
  //       </ul>
  //       <p  style="padding-top:15px;"><strong>Quick Connect - Is the gas empty?</strong></p>
      

        
  //       <h4>Screw-In System</h4>
  //       <ul>
  //         <li>Make sure the cylinder is properly inserted in the cylinder holder by screwing the cylinder counter-clockwise while applying gentle pressure until it is firmly held in place. Do not use tools and make sure the cylinder is secured in its place.</li>
  //       </ul>
  //       <p  style="padding-top:15px;"><strong>Screw-In - Is the gas empty?</strong></p>
       


    
  //       <p>If you are still not getting bubbles, you may be out of CO2. You can buy a new cylinder
  //       <a href="https://example.com/get-backup-cylinder" target="_blank" rel="noopener noreferrer">online</a>
  //         or at our participating  <a href="https://example.com/get-backup-cylinder" target="_blank" 
  //         rel="noopener noreferrer">retailers</a>.</p>
    
  //       <p><strong>Pro-tip:</strong> SodaStream recommends having at least 3 cylinders on hand, so you’ll always have bubbles and so you can exchange 2 at a time.</p>
    
  //       <p><strong>SodaStream CO2 Screw-In System Cylinder</strong></p>
  //     `,
  //   },
  //   {
  //     title:
  //       "What cylinders can I use with my SodaStream Sparkling Water Maker?",
  //     content: `
  //       <p>If your SodaStream Sparkling Water Maker is compatible with the SodaStream Quick Connect CO2 cylinder, you should order the Original SodaStream CO2 Cylinder with a fresh new look and the Pink valve seal on top.</p>
        
  //       <p>If your SodaStream Sparkling Water Maker is compatible with the Screw-In CO2 cylinder, you should order the cylinder with the Blue valve seal on top – no design changes have been made to this CO2 cylinder.</p>
  //       <img src="https://sodastream.co.uk/cdn/shop/files/Cylinder-US_91c78c62-3d3d-450b-a19b-327a17ac1e7b.png?v=1711025553" alt="CO2 Cylinders representation" style="width: 150px; height: 150px; padding:15px;" />
  //       <p><strong>Wonder what to do with your current SodaStream CO2 Cylinder?</strong></p>
  //       <p>Don't worry! Our CO2 cylinders are reusable and refillable. Exchange your SodaStream 
  //       Quick Connect CO2 cylinder only if it is out of CO2. SodaStream CO2 Cylinder exchange is available
  //       <a href="https://www.sodastream.co.za/co2-gas-cylinders" target="_blank" rel="noopener noreferrer"><u>online</u></a>
  //       or at a local  <a href="https://www.sodastream.co.za/store-locator" target="_blank" rel="noopener noreferrer"><u>retail store</u></a>.</p>
        
  //       <p><strong>Sparkle Note:</strong> Using non-SodaStream cylinders is not a good idea. All our CO2 cylinders are quality-tested when refilled.
  //        SodaStream CO2 cylinders should only be maintained and refilled by SodaStream. Unauthorised refilling of cylinders by third parties could be risky. 
  //        SodaStream only warrants the safety of cylinders refilled by us, and SodaStream is not responsible for products of any other company or brand, which may damage the Sparkling Water Maker and void the warranty.</p>
  //     `,
  //   },

  //   {
  //     title: "Where can I exchange my empty CO2 cylinder?",
  //     content: `
  //       <p>Our CO2 cylinders are reusable and refillable. Exchange your SodaStream Quick Connect CO2 cylinder only if it is out of CO2.
  //        SodaStream CO2 Cylinder exchange is available  <a href="https://www.sodastream.co.za/co2-gas-cylinders" target="_blank" rel="noopener
  //         noreferrer"><u>online</u></a> or at a local  <a href="https://www.sodastream.co.za/store-locator" target="_blank" rel="noopener noreferrer"><u>retail store</u></a>.</p>.</p>
  //     `,
  //   },

  //   {
  //     title:
  //       "Can I exchange my SodaStream Screw-In System Cylinder for a SodaStream Quick Connect Cylinder?",
  //     content: `
  //       <p>You sure can! You can exchange your existing cylinder for the SodaStream Quick Connect Cylinder
  //        at a <a href="https://www.sodastream.co.za/store-locator" target="_blank" rel="noopener noreferrer"><u>retail location</u></a>
  //         which carries them or on our <a href="https://sodastream.co.za" target="_blank" rel="noopener noreferrer"><u>website</u></a>
  //     `,
  //   },

  //   {
  //     title:
  //       "What's the difference between exchange versus back-up carbonating cylinders?",
  //     content: `
  //       <p>With a CO2 exchange, you return any empty SodaStream cylinder and just pay the price of the CO2 for a new cylinder. You can easily exchange your carbonating cylinder at a retail location near you.</p>
        
  //       <p>A spare cylinder is there so you never run out of CO2. You pay for the license of the cylinder and the CO2. SodaStream recommends having at least 3 cylinders on hand, so you’ll always have bubbles and so you can exchange 2 at a time, taking advantage of the reduced shipping charge.</p>
        
  //       <p>Get your back-up CO2 cylinder  <a href="https://sodastream.co.za" target="_blank" rel="noopener noreferrer"><u>here</u></a>
  //     `,
  //   },
  //   {
  //     title: "What are the benefits of SodaStream CO2 cylinders?",
  //     content: `
  //       <p>There are many reasons to purchase SodaStream cylinders:</p>
        
  //       <h4>Experience</h4>
  //       <p>SodaStream has years of experience in perfecting the manufacturing of home carbonation systems and cylinders, making us the world leader in home carbonation systems. SodaStream cylinders can be found in over 45 countries, over 100,000 stores, and in millions of households. We were the first ever to introduce the aluminum CO2 cylinder for Sparkling Water Makers and are now the world’s largest manufacturer of aluminum cylinders (for cylinders up to 2 kg), with millions of CO2 cylinders manufactured and in circulation.</p>
        
  //       <h4>Safety</h4>
  //       <p>SodaStream makes safety a priority. Not only has SodaStream secured recognition from the world’s leading regulatory and safety authorities, but as a self-certified manufacturer, SodaStream sets the standards at a much higher level, far exceeding the legal requirements set by the respective regulators. SodaStream-manufactured cylinders benefit from in-house filling, refilling, testing, and maintenance, all done in SodaStream’s state-of-the-art manufacturing plants. Each SodaStream-manufactured cylinder and valve are inspected individually, and both the cylinder and valve are traceable back to the batch of raw materials from which it was produced. SodaStream-produced valves are designed to prevent leakage and help ensure safety in the case of unexpected increases in internal pressure.</p>
        
  //       <h4>Quality</h4>
  //       <p>SodaStream offers triple quality control – clean, fill, and seal. All cylinders filled by SodaStream undergo a triple quality control system where they are cleaned with a special cleaning process, filled with the highest purity beverage quality CO2, and sealed with SodaStream tamper-proof covers. We have refilling facilities all over the world tailored to the specialized inspection, maintenance, and refilling of SodaStream cylinders, where every cylinder is individually inspected for damage or tampering before being refilled and tested.</p>
  //     `,
  //   },
  //   {
  //     title:
  //       "Is the Quick Connect Cylinder available at the same locations as the Screw-In system cylinders?",
  //     content: `
  //       <p>Yes. You can return to the store where you purchased your Sparkling Water Maker with the Quick Connect Cylinder, or you can check out our 
  //      <a href="https://sodastream.co.za/store-locator" target="_blank" rel="noopener noreferrer"><u>store locator </u></a> to find another retailer near you.
       
  //     `,
  //   },

  //   {
  //     title:
  //       "Will high altitude have any effect on my cylinder and can I take my cylinder on a plane?",
  //     content: `
  //       <p>Although elevation will have no pressure effect on the CO2 cylinder, SodaStream advises against carrying carbonating cylinders on an airplane. Most airlines and airport security have restrictions in place that prohibit the cylinders from boarding a plane.</p>
  //     `,
  //   },
  //   {
  //     title:
  //       "Is it safe to have carbonating cylinders in my home and how should they be stored?",
  //     content: `
  //       <p>SodaStream CO2 cylinders are totally safe to have in your home. They are manufactured to exacting safety specifications to protect our consumers and are safe at virtually any altitude (our customers in the Swiss Alps can attest to that!).</p>
        
  //       <p>Our cylinders are specially equipped with a safety valve that will harmlessly release the CO2 in the unlikely event that the pressure within the carbonating cylinder rises above threshold levels. Make sure to always store your CO2 cylinder in a cool and dry environment, away from direct sunlight. The carbonating cylinder must not be exposed to sources of heat (such as prolonged travel in the trunk of a car) or placed right next to a heat source such as an oven, stove, or fireplace.</p>
  //     `,
  //   },
  //   {
  //     title:
  //       "How do you ensure that SodaStream carbonating cylinders that get refilled are clean, and can I refill the CO2 cylinders on my own?",
  //     content: `
  //       <p>Refilling your cylinders outside of SodaStream is not a good idea. Once SodaStream cylinders are received for refilling, the cylinders are emptied, tested, and cleaned prior to being refilled.</p>
    
  //       <p>Did you know that our cylinders receive secured recognition from the world’s leading regulatory and safety authorities? SodaStream cylinders offer triple quality control – clean, fill, and seal – and should only be maintained and refilled by SodaStream.</p>
    
  //       <p>Unauthorised refilling of cylinders by third parties could be risky. SodaStream only warrants the safety of cylinders refilled by us, and SodaStream is not responsible for products of any other company or brand, which may damage the Sparkling Water Maker. Such damage for the Sparkling Water Maker resulting from use of third party products is not covered by the Sparkling Water Maker Warranty.
  //       </p>
  //       <img src="https://sodastream.co.uk/cdn/shop/files/Cylinder-US_91c78c62-3d3d-450b-a19b-327a17ac1e7b.png?v=1711025553" alt="CO2 Cylinders representation" style="width: 150px; height: 150px; padding:15px;" />
  //     `,
  //   },
  //   {
  //     title: "What are your CO2 cylinders made from?",
  //     content: `
  //       <p>The body of our CO2 cylinders is aluminum while the valves are brass. Enjoy the durability of our cylinders!</p>
  //     `,
  //   },
  // ];

  const { addToCart } = useCart();
  const [selectedBanner, setSelectedBanner] = useState<string>("");
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
    null
  );
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [quantity, setQuantity] = useState<number>(1);
  const [orderType, setOrderType] = useState<string>("exchange");

  const [faqs, ] = useState<Faq[]>([]);


  const handleCardClick = (banner: string, id: number, orderType: string) => {
    setSelectedBanner(banner);
    setSelectedProductId(id);
    setOrderType(orderType);
    setErrorMessage("");
    setQuantity(1);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedProductId) {
      setErrorMessage("Please choose an item");
      notify("Please choose an item", "error");
    } else {
      const selectedProduct = products.find(
        (product) => product.id === selectedProductId
      );
      if (selectedProduct) {
        addToCart({ ...selectedProduct, order_type: orderType }, quantity);
        // setAddedProduct({
        //   ...selectedProduct,
        //   quantity,
        //   order_type: orderType,
        // });
      
        // setIsCartModalVisible(true);
        setErrorMessage("");
        notify("Product has been successfully added to cart!", "success");
      }
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
 
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOptionSelect = (option: string) => {
    // setSelectedOption(option);
    setIsModalVisible(false);

    if (option === "art") {
      handleCardClick(
        "https://sodastream.com/cdn/shop/products/bundle-blue-cyl-US.png?v=1708601134",
        36,
        orderType
      );
    } else if (option === "terra") {
      handleCardClick(
        "https://sodastream.com/cdn/shop/files/spare_2048pxX2048pxcopy2_9dc8c174-153a-48a6-8c25-6d3b90daf98b.png?v=1708694033",
        31,
        orderType
      );
    }
  };

  const cards = [
    {
      key: "art",
      title: "Art",
      description: "Uses Screw in cylinder",
      imgSrc:
        "http://res.cloudinary.com/brabenjos/image/upload/v1704885569/sodastream/1704885569491.jpg",
    },
    {
      key: "terra",
      title: "Terra",
      description: "Uses CQC cylinder",
      imgSrc:
        "http://res.cloudinary.com/brabenjos/image/upload/v1704519766/sodastream/1704519766224.jpg",
    },
    {
      key: "terra2",
      title: "Terra",
      description: "Uses CQC cylinder",
      imgSrc:
        "http://res.cloudinary.com/brabenjos/image/upload/v1704519766/sodastream/1704519766224.jpg",
    },
    {
      key: "terra3",
      title: "Terra",
      description: "Uses CQC cylinder",
      imgSrc:
        "http://res.cloudinary.com/brabenjos/image/upload/v1704519766/sodastream/1704519766224.jpg",
    },
  ];
  const fetchProductData = async () => {
    setLoading(true);
    try {
      const { data, error } = await ProductService.getAllProducts();
      if (data) {
        const filteredData = data.filter(
          (product) => product.product_type === "cylinders" && product.category === "empty"
        );
        setProducts(filteredData);
      } else {
        console.error("Error fetching products:", error);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductData();
  }, []);
  const groupedCards = [];
  for (let i = 0; i < cards.length; i += 2) {
    groupedCards.push(cards.slice(i, i + 2));
  }


  return (
    <>
      <div className="">
        <Header
          title="Exchange your empty cylinders"
          subTitle="Exchange your empty cylinders"
          backgroundImg={Images.Page6BG}
          textBackground="GAS CYLINDERS"
          desktopHeight="60vh"
        />

        <SectionTitle title="Exchange your empty cylinders" />

        <section>
          <div className="flex md:flex-row flex-col gap-0 relative">
            <div className="basis-[100%] md:px-20 md:py-20 p-10 flex text-[#005D6E] text-start">
              <div className="basis-[45%] hidden md:block bg-[#efebe4] h-[550px]">
              <img
                  className=""
                  src={
                    selectedBanner ||
                    "https://sodastream.co.uk/cdn/shop/files/bundle-pink-cyl-US_316b0f42-10b5-410a-86ba-89e67a601427.png?v=1710935941"
                  }
                  alt="Co2 gas cylinders"
                  style={{ width: "100%" }}
                />
              
              </div>
              <div className="basis-[100%] md:basis-[45%] flex flex-col gap-4 w-1/2 ">
                <div className="flex-1 bg-white m-2 ml-0 md:ml-[90px]">
                  <section className="flex flex-col md:flex-row 0 mb-3">
                    <div className="flex-1 bg-white m-2 flex flex-col justify-between">
                      <div className="flex   gap-2 w-full justify-between">
                        <h2 className="flex items-center justify-between box-border text-[#005D6E] text-xl font-black leading-normal mb-2.5 text-left font-poppins w-full">
                          Which cylinder do you use?
                          <p
                            className="text-[#005D6E] cursor-pointer text-xs font-black leading-normal relative tracking-wider font-poppins"
                            onClick={showModal}>
                            Not Sure?
                          </p>
                        </h2>
                      </div>
                      <section className="">
                        {loading ? (
                          <Loader />
                        ) : (
                          <div className="flex md:flex-row gap-4">
                            {/* {products.map((product) => (
                              <CylindersProduct
                                key={product.id}
                                id={product.id}
                                title={product.name}
                                price={product.price}
                                image={product.image}
                                banner={product.banner}
                                isSelected={selectedProductId === product.id}
                                onClick={(banner) =>
                                  handleCardClick(banner, product.id, orderType)
                                }
                              />
                            ))} */}
                          </div>
                        )}
                      </section>
                    </div>
                  </section>
                  {errorMessage && (
                    <p className="text-red-500 mt-2">{errorMessage}</p>
                  )}
                  {/* <QuantityForm
                    quantity={quantity}
                    onIncrement={handleIncrease}
                    onDecrement={handleDecrease}
                    maxQuantity={maxQuantity}
                    setQuantity={setQuantity}
                    selectedProductId={selectedProductId}
                    legend="How many empties do you need to exchange?"
                  /> */}
                  {/* <HoverWarning quantity={quantity} /> */}
                  <CartSubscribeSection handleSubmit={handleSubmit} />
                </div>
              </div>
            </div>
          </div>
        </section>

        <div>
          <ExchangeOptions
            onlineExchange={cardData}
            storeExchange={cardData2}
          />
          <RefillFAQ
            faqs={faqs}
            toggleSection={toggleSection}
            openSections={openSections}
          />
          <RefillModalSelection
            isModalVisible={isModalVisible}
            handleCancel={handleCancel}
            handleOptionSelect={handleOptionSelect}
            groupedCards={groupedCards}
          />
          {/* <CartModal
            isCartModalVisible={isCartModalVisible}
            setIsCartModalVisible={setIsCartModalVisible}
            addedProduct={addedProduct}
            handleDecrease={handleDecrease}
            handleIncrease={handleIncrease}
            availableStock={availableStock}
          /> */}
          <div></div>
          <div></div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Refill;
